import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { FontStyleDetailWrapper, LocalService, Status } from 'src/service/local.service';
import { PrinterService } from 'src/service/printer.service';

@Component({
  selector: 'app-font-settings-config',
  templateUrl: './font-settings-config.component.html',
  styleUrl: './font-settings-config.component.scss'
})
export class FontSettingsConfigComponent {
  @ViewChild('content_font_setting_config')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() businessId: string = '';
  data: FontStyleDetailWrapper; searchLanguage: string = '';

  elementIds: any = {
    save: "btn_font_setting_config_save",
    fontName: 'txt_font_setting_config_font_name',
    lineHeight: 'txt_font_setting_config_line_height',
    itemsLineHeight: 'txt_font_setting_config_items_line_height',
    fontSize: 'txt_font_setting_config_font_size',
    search: 'txt_font_setting_config_search'
  };

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private printerService: PrinterService) {
  }

  ngOnInit(): void {
    this.onInitiate();
  }

  onInitiate() {

  }


  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    if (this.businessId && this.businessId.length > 5) {
      this.printerService.getPrintFontSettingByBusinessId(this.businessId, true).subscribe(result => {
        this.data = result;
        this.onFillFontTitle();
      });
    }
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onSave();
      } break;
    }
  }

  onFillFontTitle() {
    this.data.fontNameOptions?.forEach(fontNameOption => {
      const title = this.localService.getEquivalentTitle(fontNameOption.languageCode);
      fontNameOption.value = title;
      fontNameOption.s_value = title + ';' + title.toLowerCase();
    });
    if (this.data.fontNameOptions) {
      this.data.fontNameOptions = this.localService.Sort(this.data.fontNameOptions, true, "value");
    }
  }

  onSave() {
    if (this.businessId && this.businessId.length > 0) {
      this.data.businessId = this.businessId;
      this.printerService.saveFontSetting(this.data).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        if (result.status == Status.Success) {
          this.onCloseTrigger();
        }
      });
    }
  }
}
